import FormInputs from "../../components/UI/FormInputs";
import { _t } from "../../utils/i18nUtils";
import { useEffect } from "react";
import CustomPasswordStrengthBar from "./CustomPasswordStrengthBar";
import { Link } from "react-router-dom";

const PasswordForm = (props) => {
  let { clearForm, title, formInputs, formData, validation, inputChangeHandler, submitHandler }=props

  const handlePasswordChange = (Score, Feedback) => {
    // console.log("handlePasswordChange,",Score,Feedback);
    validation={...validation,['enterpassword']:Feedback.suggestions}
    // console.log('validation',validation);

  };
  useEffect(()=>{
    clearForm();
  },[title]);

  return (
    <div className="sh_login">
      <div className="sh_login-bleed">
        <main className="sh_login-bg">
          <div className="container sh_login-container">
            <div className="row justify-content-center">
              <div className="col-12">
                <div className="sh_login-hero text-center">
                  <div className="sh_login-brand">SnapEHR</div>
                  <div className="sh_login-title">A New Generation Has Arrived</div>
                  <div className="sh_login-subtitle">
                    Healthcare technology finally built for the way modern medicine works.
                  </div>
                </div>

                <div className="d-flex justify-content-center">
                  <div className="sh_login-card">
                    <div className="sh_login-card-inner">
                      <div className="sh_login-card-title">{_t(title)}</div>
                      {props.description ? (
                        <div className="sh_login-card-subtitle">{props.description}</div>
                      ) : null}

                      <form
                        className="mt-3"
                        onSubmit={(e) => {
                          e.preventDefault();
                          submitHandler();
                        }}
                      >
                        {formInputs.map((formInput, index) => (
                          <div className="mb-3" key={index}>
                            {formInput.name === 'email' ? (
                              <div className="sh_login-input">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <rect
                                    x="2"
                                    y="3"
                                    width="12"
                                    height="10"
                                    rx="2"
                                    stroke="#4A505C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                  <path
                                    d="M4.66602 5.98926L7.4691 7.21142C7.80763 7.35902 8.19222 7.3596 8.53119 7.21302L11.3327 6.00167"
                                    stroke="#4A505C"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                                <input
                                  type="email"
                                  className="form-control sh_login-control"
                                  placeholder={formInput.placeHolder}
                                  name={formInput.name}
                                  value={formInput.value}
                                  onChange={(e) =>
                                    inputChangeHandler(e.target.value, e, formInput.name)
                                  }
                                />
                              </div>
                            ) : (
                              <FormInputs
                                type={formInput.type}
                                placeholder={formInput.placeHolder}
                                className="form-control form-control-fields sh_login-control"
                                name={formInput.name}
                                changeHandler={(value, { e }) =>
                                  inputChangeHandler(value, e, formInput.name)
                                }
                                value={formInput.value}
                              />
                            )}
                            {formInput.isPassword && formInput.value !== '' ? (
                              <CustomPasswordStrengthBar
                                password={formInput.value}
                                onChangeHandler={handlePasswordChange}
                              />
                            ) : (
                              ''
                            )}
                            {Array.isArray(validation[formInput.name]) ? (
                              validation[formInput.name].map((itm, errIdx) => (
                                <div key={`${formInput.name}-${errIdx}`}>
                                  <span className="text-danger m-1">{itm}</span>
                                  <br />
                                </div>
                              ))
                            ) : (
                              <>
                                <span className="text-danger m-1">{validation[formInput.name]}</span>
                                <br />
                              </>
                            )}
                          </div>
                        ))}

                        <button type="submit" className="btn sh_login-btn w-100">
                          {props.submmitButton}
                        </button>

                        <div className="sh_login-register mt-3 text-center">
                          <Link to="/login" className="sh_login-link">
                            {_t('returnToLogin')}
                          </Link>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};
export default PasswordForm;